export const COLORS = {
  white: '#fff',
  roomWhite: '#E8E8E8',
  dark: '#1A202C',
  roomDark: '#263238',
};
